import React, { useContext } from "react";
import TextFieldWithStyle from "../../../HOCs/InputWithStyle/InputWithStyle";
import ButtonWithStyle from "../../../HOCs/ButtonWithStyle/ButtonWithStyle";
import { AuthContext } from "../../../AuthContext";
import { useForm } from "react-hook-form";

export default function LoginForm(props) {
	const { handleSubmit, register } = useForm();
	const { toggleForm } = props;
	const { logIn } = useContext(AuthContext);

	function onSubmit(data) {
		logIn(data);
	}

	return (
		<form data-testid="form" onSubmit={handleSubmit(onSubmit)} style={{ textAlign: "center" }}>
			<h1 style={{ color: "#000", textAlign: "center", margin: "0" }}>Login</h1>
			<TextFieldWithStyle
				style={{ maxWidth: "300px" }}
				margin="normal"
				required
				fullWidth
				id="email"
				label="Email Address"
				name="email"
				autoComplete="email"
				autoFocus
				type="email"
				inputRef={register}
			/>
			<TextFieldWithStyle
				style={{ maxWidth: "300px" }}
				margin="normal"
				required
				fullWidth
				id="password"
				label="Password"
				name="password"
				type="password"
				autoFocus
				inputRef={register}
			/>
			<ButtonWithStyle variant="contained" type="submit">
				Submit
			</ButtonWithStyle>
			<ButtonWithStyle variant="contained" onClick={toggleForm}>
				Return
			</ButtonWithStyle>
		</form>
	);
}
